import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import MessagePanel from 'components/ui/layout/panel/MessagePanel';

import {HTTP_STATUS_NOTFOUND} from 'util/api/Api';

/** Component to render an Authorization Error Panel  */
class NotFoundPanel extends Component {

    render() {
        const {
            intl:{formatMessage}
        } = this.props;

        return (
            <MessagePanel
                code={HTTP_STATUS_NOTFOUND}
                title={formatMessage({id: 'title.page_not_found'})}
                message={formatMessage({id: 'title.nothing_to_see'})}/>
        );
    }
}

export default injectIntl(NotFoundPanel);





// WEBPACK FOOTER //
// ./src/components/ui/layout/error/NotFoundPanel.jsx